import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import API from "../../api/axiosConfig";
import { toast } from "react-toastify";
import { X } from "lucide-react";

export default function CreateUserModal({ companyId, onClose, onUserCreated, roles = [], sedes = [] }) {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", password: "", companyRoleId: "", sedeId: "" });

  const handleCreate = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.password) {
      toast.warn("Completa todos los campos");
      return;
    }
    if (!form.sedeId) {
      toast.warn("Asigna una sede al empleado");
      return;
    }

    try {
      setLoading(true);
      await API.post(`/companies/${companyId}/users`, form);
      toast.success("Usuario creado con éxito");
      onUserCreated();
      onClose();
    } catch (err) {
      const msg = err.response?.data?.message || "Error al crear usuario";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AnimatePresence>
      <motion.div
        className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 px-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <motion.div
          className="bg-white rounded-2xl p-6 w-full max-w-md sm:max-w-lg shadow-lg relative max-h-[90vh] overflow-y-auto"
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.9, opacity: 0 }}
        >
          <button
            onClick={onClose}
            className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
          >
            <X size={20} />
          </button>

          <h3 className="text-lg font-semibold text-gray-800 mb-4">
            Crear nuevo usuario
          </h3>

          <form onSubmit={handleCreate} className="grid gap-4">
            <input
              placeholder="Nombre completo"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              className="border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-supernova-400 w-full"
            />
            <input
              type="email"
              placeholder="Correo electrónico"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-supernova-400 w-full"
            />
            <input
              type="password"
              placeholder="Contraseña"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-supernova-400 w-full"
            />
            <div>
              <label className="text-xs font-bold text-gray-500 mb-1 block">Rol de empresa</label>
              <select
                value={form.companyRoleId}
                onChange={(e) => setForm({ ...form, companyRoleId: e.target.value })}
                className="border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-supernova-400 w-full"
              >
                <option value="">Sin rol (todos los módulos)</option>
                {roles.map((r) => <option key={r.id} value={r.id}>{r.name}</option>)}
              </select>
            </div>
            <div>
              <label className="text-xs font-bold text-gray-500 mb-1 block">Sede *</label>
              <select
                value={form.sedeId}
                onChange={(e) => setForm({ ...form, sedeId: e.target.value })}
                className="border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-supernova-400 w-full"
              >
                <option value="">Selecciona una sede</option>
                {sedes.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
              </select>
              <p className="text-[11px] text-gray-400 mt-1">Solo podrá ver y atender mesas, pedidos e impresoras de esta sede.</p>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="bg-supernova-500 hover:bg-supernova-600 text-white py-3 rounded-lg transition"
            >
              {loading ? "Creando..." : "Crear usuario"}
            </button>
          </form>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
